import React from 'react'
import PropTypes from 'prop-types'

// kolodny immutability-helper
//   https://github.com/kolodny/immutability-helper
//   npm install --save immutability-helper
import update from 'immutability-helper'

// Material-UI
//   npm install --save material-ui
import TextField from 'material-ui/TextField'
import Checkbox from 'material-ui/Checkbox'

// 自作ユーティリティ・ツール
import * as GridUtils from '../GridUtils'
import * as def from '../define'
import EntryGuidance from '../EntryGuidance'
import { toHalfWidth, containsZenkaku, shiftJISLength, showMaintenanceDlg } from '../utils'
// import { charConverter } from './charConverter'

// Ajax
import { checkContractId, checkErrorCode } from '../webapi'

import '../App.css'

/**
 * 各項目の入力
 */
export default class EntryInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      info: Object.assign({}, this.props.info),
      contractIdMessage: '',
      msgContractIdStyle: {},
      etContractId: '',
      etCompanyId: '',
      etCompanyName: '',
      etCompanyPW1: '',
      etCompanyPW2: '',
      etAdminId: '',
      etAdminName: '',
      etAdminMailAddress: '',
      etAdminPW1: '',
      etAdminPW2: '',
      isSubmitAllowed: false
    }
    this.mailConfirmationCode = ''
    this.mailConfirmationCodeWillExpire = null
    this.judgeSubmit = this.judgeSubmit.bind(this)
    this.changeContractId = this.changeContractId.bind(this)
    this.handleContractIdChange = this.handleContractIdChange.bind(this)
    // this.contractIdBlur = this.contractIdBlur.bind(this)
    this.changeCompanyId = this.changeCompanyId.bind(this)
    this.handleCompanyIdChange = this.handleCompanyIdChange.bind(this)
    // this.companyIdBlur = this.companyIdBlur.bind(this)
    this.handleCompanyNameCommon = this.handleCompanyNameCommon.bind(this)
    this.handleCompanyNameChange = this.handleCompanyNameChange.bind(this)
    this.handleCompanyNameBlur = this.handleCompanyNameBlur.bind(this)
    this.handleCompanyPW1Change = this.handleCompanyPW1Change.bind(this)
    this.handleCompanyPW2Change = this.handleCompanyPW2Change.bind(this)
    this.handlePWEffectiveDaysChange = this.handlePWEffectiveDaysChange.bind(this)
    this.handleNeedPictureChange = this.handleNeedPictureChange.bind(this)
    this.handleNeedLocationChange = this.handleNeedLocationChange.bind(this)
    this.chageAdminId = this.changeAdminId.bind(this)
    this.handleAdminIdChange = this.handleAdminIdChange.bind(this)
    // this.adminIdBlur = this.adminIdBlur.bind(this)
    this.handleAdminNameCommon = this.handleAdminNameCommon.bind(this)
    this.handleAdminNameChange = this.handleAdminNameChange.bind(this)
    this.handleAdminNameBlur = this.handleAdminNameBlur.bind(this)
    this.handleAdminMailAddressChange = this.handleAdminMailAddressChange.bind(this)
    this.handleAdminPW1Change = this.handleAdminPW1Change.bind(this)
    this.handleAdminPW2Change = this.handleAdminPW2Change.bind(this)
    this.checkContractId = this.checkContractId.bind(this)
    this.handleBtnRegisterClick = this.handleBtnRegisterClick.bind(this)
    this.handleBtnCancelClick = this.handleBtnCancelClick.bind(this)
  }

  // すべての項目が有効かどうかを判定
  judgeSubmit() {
    return ((this.state.info.contractId.length >= def.lengthInfo.contract.id.min) && (this.state.info.contractId.length <= def.lengthInfo.contract.id.max)) &&
      (this.state.info.contractId.match(/^[0-9A-Za-z]+$/) !== null) &&
      ((this.state.info.companyId.length >= def.lengthInfo.company.id.min) && (this.state.info.companyId.length <= def.lengthInfo.company.id.max)) &&
      (this.state.info.companyId.match(/^[0-9A-Za-z]+$/) !== null) &&
      ((shiftJISLength(this.state.info.companyName) >= def.lengthInfo.company.name.min) && (shiftJISLength(this.state.info.companyName) <= def.lengthInfo.company.name.max)) &&
      ((this.state.info.companyPW1.trim().length > 0) && (this.state.info.companyPW1.length >= def.lengthInfo.company.pw.min) && (this.state.info.companyPW1.length <= def.lengthInfo.company.pw.max)) &&
      ((this.state.info.companyPW2.trim().length > 0) && (this.state.info.companyPW2.length >= def.lengthInfo.company.pw.min) && (this.state.info.companyPW2.length <= def.lengthInfo.company.pw.max)) &&
      (this.state.info.companyPW1 === this.state.info.companyPW2) &&
      ((this.state.info.adminId.length >= def.lengthInfo.admin.id.min) && (this.state.info.adminId.length <= def.lengthInfo.admin.id.max)) &&
      (this.state.info.adminId.match(/^[0-9A-Za-z\-_]+$/) !== null) &&
      ((shiftJISLength(this.state.info.adminName) >= def.lengthInfo.admin.name.min) && (shiftJISLength(this.state.info.adminName) <= def.lengthInfo.admin.name.max)) &&
      ((this.state.info.adminMailAddress.length >= def.lengthInfo.contract.mail.min) && (this.state.info.adminMailAddress.length <= def.lengthInfo.contract.mail.max)) &&
      ((this.state.info.adminPW1.trim().length > 0) && (this.state.info.adminPW1.length >= def.lengthInfo.admin.pw.min) && (this.state.info.adminPW1.length <= def.lengthInfo.admin.pw.max)) &&
      ((this.state.info.adminPW2.trim().length > 0) && (this.state.info.adminPW2.length >= def.lengthInfo.admin.pw.min) && (this.state.info.adminPW2.length <= def.lengthInfo.admin.pw.max)) &&
      (this.state.info.adminPW1 === this.state.info.adminPW2)
  }

  // 契約ID
  changeContractId(v) {
    if (this.state.info.contractId !== v) {
      let et = this.state.etContractId
      if (v.length < 1) {
        et = '必須項目'
      } else if ((v.length < def.lengthInfo.contract.id.min) || (v.length > def.lengthInfo.contract.id.max)) {
        et = '半角英数字 ' + def.lengthInfo.contract.id.min + '〜' + def.lengthInfo.contract.id.max + '文字'
      } else if (containsZenkaku(v)) {
        et = '全角文字や半角カナは使用できません'
      } else if (v.match(/^[0-9A-Za-z]+$/) === null) {
        et = '半角英数字以外は使用できません'
      } else {
        et = ''
      }
      this.setState({ info: update(this.state.info, { contractId: { $set: v } }), etContractId: et, isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 契約ID
  handleContractIdChange(e) {
    this.changeContractId(e.target.value)
  }

  // フォーカスが外れたところで半角変換
  // contractIdBlur () {
  // this.changeContractId(charConverter.convertToHankaku(this.state.info.contractId))
  // }

  // メールアドレス
  handleAdminMailAddressChange(e) {
    let v = toHalfWidth(e.target.value)
    if (this.state.info.adminMailAddress !== v) {
      let et = this.state.etAdminMailAddress
      if (v.length < 1) {
        et = '必須項目'
      } else if ((v.length < def.lengthInfo.contract.mail.min) || (v.length > def.lengthInfo.contract.mail.max)) {
        et = '半角文字 ' + def.lengthInfo.contract.mail.max + '文字以内'
      } else if (v.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) === null) {
        // 上記の正規表現は https://qiita.com/sakuro/items/1eaa307609ceaaf51123 を参考にした
        et = 'メールアドレスの形になっていません。'
      } else {
        et = ''
      }
      this.setState({ info: update(this.state.info, { adminMailAddress: { $set: v } }), etAdminMailAddress: et, isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 会社ID
  changeCompanyId(v) {
    if (this.state.info.companyId !== v) {
      let et = this.state.etCompanyId
      if (v.length < 1) {
        et = '必須項目'
      } else if ((v.length < def.lengthInfo.company.id.min) || (v.length > def.lengthInfo.company.id.max)) {
        et = '半角文字 ' + def.lengthInfo.company.id.max + '文字以内'
      } else if (containsZenkaku(v)) {
        et = '全角文字や半角カナは使用できません'
      } else if (v.match(/^[0-9A-Za-z]+$/) === null) {
        et = '半角英数字以外は使用できません'
      } else {
        et = ''
      }
      this.setState({ info: update(this.state.info, { companyId: { $set: v } }), etCompanyId: et, isSubmitAllowed: this.judgeSubmit() })
    }
  }

  handleCompanyIdChange(e) {
    this.changeCompanyId(e.target.value)
  }

  // companyIdBlur () {
  // this.changeCompanyId(charConverter.convertToHankaku(this.state.info.companyId))
  // }

  // 会社名称
  handleCompanyNameCommon(nm) {
    if (this.state.info.companyName !== nm) {
      let et = this.state.etCompanyName
      if (shiftJISLength(nm) > def.lengthInfo.company.name.max) {
        et = '半角文字換算' + def.lengthInfo.company.name.max + '文字以内'
      } else {
        et = ''
      }
      this.setState({ info: update(this.state.info, { companyName: { $set: nm } }), etCompanyName: et, isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 会社名称
  // onChange
  handleCompanyNameChange(e) {
    this.handleCompanyNameCommon(e.target.value)
  }

  // 名称
  // フォーカスが外れるときに、先頭と末尾の空白を除去
  handleCompanyNameBlur(ev, eventArgs) {
    let v = ev.target.value.trim()
    ev.target.value = v
    this.handleCompanyNameCommon(v)
  }

  // 会社パスワード
  handleCompanyPW1Change(e) {
    let v = e.target.value
    if (this.state.info.companyPW1 !== v) {
      let et1 = this.state.etCompanyPW1
      let et2 = this.state.etCompanyPW2
      if (v.length < 1) {
        et1 = '必須項目'
      } else if (v.trim().length < 1) {
        et1 = 'スペース以外の文字も含めてください。'
      } else if ((v.length < def.lengthInfo.company.pw.min) || (v.length > def.lengthInfo.company.pw.max)) {
        et1 = '半角文字 ' + def.lengthInfo.company.pw.min + '〜' + def.lengthInfo.company.pw.max + '文字'
      } else {
        et1 = ''
      }
      if ((v === this.state.info.companyPW2) && (this.state.etCompanyPW2 === 'パスワードが一致していません。')) {
        et2 = ''
      }
      this.setState({ info: update(this.state.info, { companyPW1: { $set: v } }), etCompanyPW1: et1, etCompanyPW2: et2, isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 会社パスワード (確認)
  handleCompanyPW2Change(e) {
    let v = e.target.value
    if (this.state.info.companyPW2 !== v) {
      let et = this.state.etCompanyPW2
      this.state.info.companyPW2 = v // eslint-disable-line react/no-direct-mutation-state
      if (v.length < 1) {
        et = '必須項目' // eslint-disable-line react/no-direct-mutation-state
      } else if (v.trim().length < 1) {
        et = 'スペース以外の文字も含めてください。'
      } else if ((v.length < def.lengthInfo.company.pw.min) || (v.length > def.lengthInfo.company.pw.max)) {
        et = '半角文字 ' + def.lengthInfo.company.pw.min + '〜' + def.lengthInfo.company.pw.max + '文字' // eslint-disable-line react/no-direct-mutation-state
      } else if (v !== this.state.info.companyPW1) {
        et = 'パスワードが一致していません。' // eslint-disable-line react/no-direct-mutation-state
      } else {
        et = '' // eslint-disable-line react/no-direct-mutation-state
      }
      this.setState({ info: update(this.state.info, { companyPW2: { $set: v } }), etCompanyPW2: et, isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // ここで数字以外の入力をはじく
  handlePWEffectiveDaysKeyDown(e) {
    // 英数字や記号のキーは文字長が1、矢印キーやタブキーのときは2文字以上
    if (e.key.length === 1) {
      if (!e.key.match(/[0-9]/)) {
        e.preventDefault()
      }
    }
  }

  // 社員パスワード有効日数
  handlePWEffectiveDaysChange(e) {
    let s = e.target.value
    if (s.length > 0) {
      let v = parseInt(s, 10)
      if (isNaN(v) || (v < 0)) {
        v = 0
      } else if (v > def.emproyeePasswordPeriodMax) {
        v = def.emproyeePasswordPeriodMax
      }
      if (this.state.info.pwEffectiveDays !== v) {
        this.setState({ info: update(this.state.info, { pwEffectiveDays: { $set: v } }), isSubmitAllowed: this.judgeSubmit() })
      }
      // デフォルトでは '01' のような先行ゼロありを許容しているので、
      // ここで矯正する
      if ((s.length > 1) && (s.charAt(0) === '0')) {
        e.target.value = v.toString(10)
      }
    } else {
      this.setState({ info: update(this.state.info, { pwEffectiveDays: { $set: 0 } }), isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 画像添付
  handleNeedPictureChange(e, isChecked) {
    let v = isChecked
    if (this.state.info.needPicture !== v) {
      this.setState({ info: update(this.state.info, { needPicture: { $set: v } }), isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 位置情報添付
  handleNeedLocationChange(e, isChecked) {
    let v = isChecked
    if (this.state.info.needLocation !== v) {
      this.setState({ info: update(this.state.info, { needLocation: { $set: v } }), isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 管理者ID
  changeAdminId(v) {
    if (this.state.info.adminId !== v) {
      let et = this.state.etAdminId
      if (v.length < 1) {
        et = '必須項目'
      } else if ((v.length < def.lengthInfo.admin.id.min) || (v.length > def.lengthInfo.admin.id.max)) {
        et = '半角英数字 ' + def.lengthInfo.admin.id.max + '文字以内'
      } else if (v.match(/^[0-9A-Za-z\-_]+$/) === null) {
        et = '半角英数字、-(ハイフン)、_(アンダースコア) 以外の文字は使用できません'
      } else {
        et = ''
      }
      this.setState({ info: update(this.state.info, { adminId: { $set: v } }), etAdminId: et, isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 管理者ID
  handleAdminIdChange(e) {
    this.changeAdminId(e.target.value)
  }

  // adminIdBlur () {
  // this.changeAdminId(charConverter.convertToHankaku(this.state.info.adminId))
  // }

  // 管理者名
  handleAdminNameCommon(nm) {
    if (this.state.info.adminName !== nm) {
      let et = this.state.etAdminName
      if (shiftJISLength(nm) > def.lengthInfo.admin.name.max) {
        et = '半角文字換算' + def.lengthInfo.admin.name.max + '文字以内'
      } else {
        et = ''
      }
      this.setState({ info: update(this.state.info, { adminName: { $set: nm } }), etAdminName: et, isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 管理者名
  // onChange
  handleAdminNameChange(e) {
    this.handleAdminNameCommon(e.target.value)
  }

  // 名称
  // フォーカスが外れるときに、先頭と末尾の空白を除去
  handleAdminNameBlur(ev, eventArgs) {
    let v = ev.target.value.trim()
    ev.target.value = v
    this.handleAdminNameCommon(v)
  }

  // 管理者パスワード
  handleAdminPW1Change(e) {
    let v = e.target.value
    if (this.state.info.adminPW1 !== v) {
      let et1 = this.state.etAdminPW1
      let et2 = this.state.etAdminPW2
      if (v.length < 1) {
        et1 = '必須項目'
      } else if (v.trim().length < 1) {
        et1 = 'スペース以外の文字も含めてください。'
      } else if ((v.length < def.lengthInfo.admin.pw.min) || (v.length > def.lengthInfo.admin.pw.max)) {
        et1 = '半角文字 ' + def.lengthInfo.admin.pw.min + '文字以上'
      } else {
        et1 = ''
      }
      if ((v === this.state.info.adminPW2) && (this.state.etAdminPW2 === 'パスワードが一致していません。')) {
        et2 = ''
      }
      this.setState({ info: update(this.state.info, { adminPW1: { $set: v } }), etAdminPW1: et1, etAdminPW2: et2, isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 管理者パスワード (確認)
  handleAdminPW2Change(e) {
    let v = e.target.value
    if (this.state.info.adminPW2 !== v) {
      let et = this.state.etAdminPW2
      if (v.length < 1) {
        et = '必須項目'
      } else if (v.trim().length < 1) {
        et = 'スペース以外の文字も含めてください。'
      } else if ((v.length < def.lengthInfo.admin.pw.min) || (v.length > def.lengthInfo.admin.pw.max)) {
        et = '半角文字 ' + def.lengthInfo.admin.pw.min + '文字以上'
      } else if (v !== this.state.info.adminPW1) {
        et = 'パスワードが一致していません。'
      } else {
        et = ''
      }
      this.setState({ info: update(this.state.info, { adminPW2: { $set: v } }), etAdminPW2: et, isSubmitAllowed: this.judgeSubmit() })
    }
  }

  // 入力された契約IDのチェック
  checkContractId() {
    checkContractId(this.props.info.token, this.state.info.contractId)
      .then(
        function (obj) {
          this.setState({ contractIdMessage: 'そのIDは既に使用されています。別のIDをご指定ください。', msgContractIdStyle: { color: 'red', fontSize: 'medium' } })
          document.getElementById('txtContractId').focus()
        }.bind(this)
      ).catch(
        function (err) {
          if (checkErrorCode(err, def.API_ERROR_CODE.MAINTENANCE)) {
            // メンテナンス中
            const endTime = err.response.body.maintenanceEndTime
            showMaintenanceDlg(this.props.callbacks.showMessage, endTime, true)
            return
          }

          if (err.status == 404) { // eslint-disable-line eqeqeq
            // OK. 使用可能
            // 次のステップへ
            this.setState({ contractIdMessage: '', msgContractIdStyle: {} })
            if (typeof this.props.callbacks.stepChange === 'function') {
              this.props.callbacks.stepChange(this.state.info, def.STEPS.INPUT_CONFIRM)
            }
          } else {
            // エラー処理
            this.setState({ contractIdMessage: '' + err.message, msgContractIdStyle: { color: 'red', fontSize: 'medium' } })
          }
        }.bind(this)
      )
  }

  // 登録ボタン
  handleBtnRegisterClick() {
    this.checkContractId()
  }

  handleBtnCancelClick() {
    if (typeof this.props.callbacks.logout === 'function') {
      this.props.callbacks.logout()
    }
  }

  render() {
    // render() 関数内では setState メソッドは使えない
    this.state.isSubmitAllowed = this.judgeSubmit() // eslint-disable-line react/no-direct-mutation-state
    // 〈打刻〉か
    const isStamp = this.state.info.serviceType === def.SERVICE_TYPE.STAMP
    const isAttendance = this.state.info.serviceType === def.SERVICE_TYPE.ATTENDANCE
    return (
      <div className='AppContent'>
        <div style={{ width: '800px', textAlign: 'left', marginLeft: 'auto', marginRight: 'auto' }}>
          <div className='GroupPane' style={GridUtils.GridColumns('300px 1fr')}>
            <h2 style={GridUtils.GridPosStyleWithColspan(1, 1, 2)}>契約情報</h2>
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(2, 1)} type='text' id='txtContractId' floatingLabelText='契約ID' hintText='半角英数字 3〜20文字' errorText={this.state.etContractId} value={this.state.info.contractId} onChange={this.handleContractIdChange} />
            <EntryGuidance row={2} col={2} style={this.state.msgContractIdStyle} id='msgContractId' message={this.state.contractIdMessage} />
          </div>
          <div className='GroupPane' style={GridUtils.GridColumns('300px 1fr')}>
            <h2 style={GridUtils.GridPosStyleWithColspan(1, 1, 2)}>ひとつめの会社情報</h2>
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(2, 1)} type='text' id='txtCompanyId' floatingLabelText='会社ID' hintText='半角英数字 20文字以内' errorText={this.state.etCompanyId} value={this.state.info.companyId} onChange={this.handleCompanyIdChange} />
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(3, 1)} type='text' id='txtCompanyName' floatingLabelText='会社名称' hintText={'半角文字換算' + def.lengthInfo.company.name.max + '文字以内'} errorText={this.state.etCompanyName} value={this.state.info.companyName} onChange={this.handleCompanyNameChange} onBlur={this.handleCompanyNameBlur} />
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(4, 1)} type='password' id='txtCompanyPW1' floatingLabelText='会社パスワード' hintText='半角文字 8〜256文字' errorText={this.state.etCompanyPW1} value={this.state.info.companyPW1} onChange={this.handleCompanyPW1Change} />
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(5, 1)} type='password' id='txtCompanyPW2' floatingLabelText='会社パスワード (確認)' hintText='半角文字 8〜256文字' errorText={this.state.etCompanyPW2} value={this.state.info.companyPW2} onChange={this.handleCompanyPW2Change} />
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(6, 1)} type='number' id='txtEffectiveDays' min='0' max={def.emproyeePasswordPeriodMax} floatingLabelText='社員パスワードの有効日数' hintText='0で無期限' value={this.state.info.pwEffectiveDays} onChange={this.handlePWEffectiveDaysChange} />
            <EntryGuidance row={6} col={2} message='各社員のパスワードの有効日数を入力してください。\n無期限にする場合は 0 としてください。' />
            {isStamp || isAttendance ? <div style={Object.assign(GridUtils.GridPosStyleWithColspan(7, 1, 2), { height: '1em' })}>&nbsp;</div> : null}
            {isStamp || isAttendance ? <Checkbox className='EntryItem' style={GridUtils.GridPosStyle(8, 1)} id='chkNeedPicture' label='画像添付' checked={this.state.info.needPicture} onCheck={this.handleNeedPictureChange} /> : null}
            {isStamp || isAttendance ? <EntryGuidance row={8} col={2} message='打刻データに画像を添付するかどうかを選択してください。' /> : null}
            {isStamp || isAttendance ? <Checkbox className='EntryItem' style={GridUtils.GridPosStyle(9, 1)} id='chkNeedLocation' label='位置情報添付' checked={this.state.info.needLocation} onCheck={this.handleNeedLocationChange} /> : null}
            {isStamp || isAttendance ? <EntryGuidance row={9} col={2} message='打刻データに位置情報を添付するかどうかを選択してください。' /> : null}
          </div>
          <div className='GroupPane' style={GridUtils.GridColumns('300px 1fr')}>
            <h2 style={GridUtils.GridPosStyleWithColspan(1, 1, 2)}>管理者情報</h2>
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(2, 1)} type='text' id='txtAdminId' floatingLabelText='管理者ID' hintText='半角英数字, -, _ 20文字以内' errorText={this.state.etAdminId} value={this.state.info.adminId} onChange={this.handleAdminIdChange} />
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(3, 1)} type='text' id='txtAdminName' floatingLabelText='管理者名' hintText={'半角文字換算' + def.lengthInfo.admin.name.max + '文字以内'} errorText={this.state.etAdminName} value={this.state.info.adminName} onChange={this.handleAdminNameChange} onBlur={this.handleAdminNameBlur} />
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(4, 1)} type='email' id='txtAdminMail' floatingLabelText='メールアドレス' hintText='半角文字 256文字以内' errorText={this.state.etAdminMailAddress} value={this.state.info.adminMailAddress} onChange={this.handleAdminMailAddressChange} />
            <EntryGuidance row={4} col={2} message='重要なお知らせをお届けするメールアドレスです。' />
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(5, 1)} type='password' id='txtAdminPW1' floatingLabelText='管理者パスワード' hintText='半角文字 8〜256文字' errorText={this.state.etAdminPW1} value={this.state.info.adminPW1} onChange={this.handleAdminPW1Change} />
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(6, 1)} type='password' id='txtAdminPW2' floatingLabelText='管理者パスワード (確認)' hintText='半角文字 8〜256文字' errorText={this.state.etAdminPW2} value={this.state.info.adminPW2} onChange={this.handleAdminPW2Change} />
          </div>
          <div style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
            <button type='button' id='btnRegister' style={{ margin: '0 40px' }} disabled={!this.state.isSubmitAllowed} onClick={this.handleBtnRegisterClick}>次　へ</button>
            <button type='button' id='btnCancel' style={{ margin: '0 40px' }} onClick={this.handleBtnCancelClick}>中　止</button>
          </div>
        </div>
      </div>
    )
  }
}

EntryInput.propTypes = {
  info: PropTypes.object.isRequired,
  callbacks: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/pages/entryInput.js